import React, { useEffect, useState } from "react";
import AppShell from "@/components/layout/AppShell";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { Users2, Mail } from "lucide-react";

const ROLE_COLORS = { super_admin: "#FF4F00", admin: "#002FA7", team: "#16A34A" };

export default function TeamPage() {
  const { lang } = useI18n();
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/team/members").then((r) => setMembers(r.data.members)); }, []);

  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl">{lang === "ar" ? "الفريق" : "Team"}</h1>
        <p className="text-muted-foreground text-sm mt-1">{lang === "ar" ? "مختصو دعم العاملون على حسابك." : "The DAAM specialists working on your account."}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="team-grid">
        {members.length === 0 && <div className="col-span-full text-muted-foreground text-sm">No team members yet.</div>}
        {members.map((m) => (
          <div key={m.id} data-testid={`team-member-${m.id}`} className="nx-card p-5">
            <div className="flex items-start gap-3">
              <div className="w-11 h-11 rounded-sm flex items-center justify-center text-white font-semibold"
                style={{ background: ROLE_COLORS[m.role] || "#002FA7" }}>
                {(m.name || m.email).slice(0, 2).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium">{m.name || m.email}</div>
                <div className="text-xs text-muted-foreground truncate flex items-center gap-1 mt-0.5"><Mail className="w-3 h-3" /> {m.email}</div>
                <div className="mt-2 inline-block text-[10px] uppercase tracking-widest px-2 py-0.5 border border-border rounded-sm">
                  {m.role.replace("_", " ")}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
